import { useHead } from "@unhead/vue";

type UseDefineTitlePage = {
  title: string;
};

export const useDefineTitlePage = ({ title }: UseDefineTitlePage) => {
  useHead({
    title: title,
  });
};
